import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { PointsDialogService } from '@app/src/app/dialog/PointsDialog/PointsDialog.service';

import { PointsDialog } from './PointsDialog.component';

@NgModule({
  imports: [
    // Minga dependencies

    // External dependencies
    CommonModule,
    MatDialogModule,
  ],

  declarations: [PointsDialog],
  exports: [PointsDialog],
  providers: [PointsDialogService],
})
export class PointsDialogModule {}
